import { FormattedMessage } from 'dibs-react-intl';

export const viewOptions = (
    <FormattedMessage
        id="pdpMobileShippingHelpers.view_shipping_options"
        defaultMessage="View Shipping Options"
    />
);

export const viewOptionsRedesign = (
    <FormattedMessage
        id="pdpMobileShippingHelpers.view_shipping_options_redesign"
        defaultMessage="View Options"
    />
);

export const requestQuote = (
    <FormattedMessage
        id="pdpMobileShippingHelpers.request_quote"
        defaultMessage="Request a quote"
    />
);

export const viewRequest = (
    <FormattedMessage id="pdpMobileShippingHelpers.view_request" defaultMessage="View Request" />
);

export const contactSeller = (
    <FormattedMessage
        id="pdpMobileShippingHelpers.contact_seller"
        defaultMessage="Contact Seller"
    />
);
